import type React from 'react';
import { EnrollView } from './EnrollView';
import { useEnroll } from './useEnroll';

/**
 * Enrollment page container. Binds the terminal to its branch by exchanging the
 * static branch API token for a device session. Thin composition point — all
 * logic is in `useEnroll`, all render in `EnrollView`.
 */
export const Enroll: React.FC = () => {
    const logic = useEnroll();
    return <EnrollView {...logic} />;
};
